import React, { useEffect, useState } from "react";
import { Table, Button, IconPlus, IconDownload, Search, Toggle, ConfirmationModal, AlertModal, IconWarningAlt, Tooltip, RadioButtons, RadioButton } from "@veneer/core";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Col, Row } from "react-bootstrap";
import XLSX from "xlsx";
import $ from 'jquery';
import COIViewModal from './COIViewModal';
import SpecialConditionDetail from "../../CPP/SpecialConditionApproval/SpecialConditionDetailAll";

const COIView = ( props ) => {
    //Variables
    const [t] = useTranslation();
    const connectApi = new ConnectAPI();
    const [dataCOI, setDataCOI] = useState([]);
    const [dataCOIRes, setDataCOIRes] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [channels, setChannels] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editValue, setEditValue] = useState(false);
    const [item, setItem] = useState({});
    const [activePress, setActivePress] = useState(false);
    const [idPressActive, setIdPressActive] = useState(false);
    const [dataPressId, setDataPressId] = useState("");
    const [dataPressActive, setDataPressActive] = useState("");
    const [reloadPage, setReloadPage] = useState(false);
    const [optionVal, setOptionVal] = useState("0");
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));

    //Metodos
    useEffect(() => {
        //validate location
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
        //end validate
        const fetchData = async () => {
            connectApi.get(
                "api/Channels/COIViewData",
                '',
                dataResponseLoad
            ).catch((error) => {
                setLoadingData(false);
                Swal.fire(
                    "Error " + error.response?.status,
                    error.response?.data,
                    "error"
                );
            });
            setLoadingData(true);
        };
        const dataResponseLoad = (status, data) => {
            data.forEach(x => {
                x.datePrintOs = moment(x.datePrintOs).format("YYYY-MM-DD");
                x.dateCOI = x.dateCOI!='0001-01-01T00:00:00'? moment(x.dateCOI).format("YYYY-MM-DD"):null;
                x.dateCOIConfirm = x.dateCOIConfirm!='0001-01-01T00:00:00'? moment(x.dateCOIConfirm).format("YYYY-MM-DD"):null;//DD/MM/YYYY
                x.dateCreate = moment(x.dateCreate).format("YYYY-MM-DD");
                x.dateLastModify = moment(x.dateLastModify).format("YYYY-MM-DD");
            });
            const dataAddToggle = data.map((item) => {
                item.activeToogle = (
                    currentUser.idRole == 1 ? (
                    <Toggle id={"id-"+item.idCOI} label={item.active==1?(t('active')):(t('inactive'))} on={item.active==1?true:false} 
                            onChange={(val) => changeActive(val, item.idCOI, item.idPress, data.filter((x) => x.idPress == item.idPress ))} />
                    ) : (
                        item.active==1?(t('active')):(t('inactive')) 
                    )
                );
                item.status = ( item.active==1?(t('active')):(t('inactive')) );
                
                if ( item.idSpecialConditon ){
                    item.idSC = ( item.idSpecialConditon.split(', ').map((x, i, z) => {
                        if (i + 1 == z.length)
                            return x.split(' ')[0]
                        else
                            return x.split(' ')[0] + " \n" 
                    }).toString().replaceAll(',', '') )
                    item.idSCEndDate = ( item.idSpecialConditon.split(', ').map((x, i, z) => { 
                        if (i + 1 == z.length)
                            return x.split(' ')[1]
                        else
                            return x.split(' ')[1] + " \n" 
                    }).toString().replaceAll(',', '')  )
                }
                
                item.idSpecialConditon = (
                    item.idSpecialConditon.split(', ').map(x => {
                        if (x.split(' ').length > 1)
                            return <div style={{ textAlign: 'end' }}><a href="#" onClick={searchIdSpecialConiiton(x.split(' ')[0])} >{x.split(' ')[0]} </a> - {x.split(' ')[1]}<br /></div>
                    })
                );
                item.idPressModify = (
                /*  1.	Prensas con SC – No alerta
                    3.	Prensas series mayor a 4 sin SC y el cliente NO tiene SC para otras prensas y SÍ tienen precio garantizado – No Alerta
                    0.	Prensa sin condición especial y el usuario no tiene condición especial. No alerta
                    2.	Prensas series menor a 4 sin SC pero el cliente tiene SC para otras prensas de la misma serie – Alerta SC
                    4.	Prensas series mayor a 4 sin SC y el cliente SÍ tiene SC para otras prensas y SÍ tienen precio garantizado – Alerta SC
                    5.	Prensas series mayor a 4 sin SC y el cliente NO tiene SC para otras prensas y NO tienen precio garantizado – Alerta precios
                    6.	Prensas series mayor a 4 sin SC y el cliente Sí tiene SC para otras prensas y NO tienen precio garantizado – Alerta SC y precios
                */
                    item.active == 0 || item.idCodeGet == 0 || item.idCodeGet == 1 || item.idCodeGet == 3 ? ( 
                        item.idPress 
                    ) : ( 
                        item.idCodeGet == 2 || item.idCodeGet == 4 ? (
                            <>{item.idPress} <Tooltip content={t("alertSC")} arrow placement="right-end" contentHideDelayOnHover={0} >
                                <IconWarningAlt filled color="colorYellow4" />
                            </Tooltip></>
                        ) : item.idCodeGet == 5 ? (
                            <>{item.idPress} <Tooltip content={t("alertGP")} arrow placement="right-end" contentHideDelayOnHover={0} >
                                <IconWarningAlt filled color="colorRed4"/>
                            </Tooltip></>
                        ) : ( 
                            <>{item.idPress} 
                            <Tooltip content={t("alertSC")} arrow placement="right-end" contentHideDelayOnHover={0} >
                                <IconWarningAlt filled color="colorYellow4" />
                            </Tooltip>
                            <Tooltip content={t("alertGP")} arrow placement="right-end" contentHideDelayOnHover={0} >
                                <IconWarningAlt filled color="colorRed4"/>
                            </Tooltip>
                            </>
                        )
                    )
                );
                item.alertSC = (
                    item.idCodeGet == 2 || item.idCodeGet == 4 || item.idCodeGet == 6 ? ( t("alertSC") ) : ("")
                );
                item.alertGP = (
                    item.idCodeGet == 5 || item.idCodeGet == 6 ? ( t("alertGP") ) : ("")
                );

                return item;
            });
            setDataCOI(dataAddToggle === undefined ? [] : dataAddToggle );
            setDataCOIRes(dataAddToggle === undefined ? [] : dataAddToggle );
            setLoadingData(false);
        };
        
        const fetchChannels = async () => {
            connectApi.get('api/Channels', '', dataResponseChannel)
            .catch((error) => {
                Swal.fire(
                    "Error " + error.response?.status,
                    error.response?.data,
                    "error"
                );
            });
        };
        const dataResponseChannel = (status, data) => {
            const items = data.map((item) => {
                if (item.type != "Inactive"){
                    return{
                        value: item.idCustomer,
                        label: item.name,
                    };
                }
            });
            let channels = items.filter(x => x)
            setChannels(channels);
        };
        fetchData();
        fetchChannels();
    },[reloadPage] );
    
    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if( orderBy === "datePrintOs" || orderBy === "dateCOI" || orderBy === "dateCOIConfirm" 
            || orderBy === "dateCreate" || orderBy === "dateLastModify" ){
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        } else if ( orderBy === "active" || orderBy === "idPress" ){
            if (parseInt(bSort) < parseInt(aSort)) 
                return -1;
            if (parseInt(bSort) > parseInt(aSort))
                return 1;
        } else {
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1; 
        }
        return 0;
    }
    function filterSort(array, filters, orderBy, orderType) {
        if(orderBy === "activeToogle")
            orderBy = "active";
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                const aUpper = a[value] && a[value].toString().toUpperCase();
                const filterUpper = filter && filter.toString().toUpperCase();
                return aUpper.indexOf(filterUpper) > -1;
                });
            });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }
    function setModalParameters(e){
        var active = $(e.target).closest('tr').children().eq(0).text();
        var idPress = $(e.target).closest('tr').children().eq(1).text().slice(0,8);
        var endUserName = $(e.target).closest('tr').children().eq(2).text();
        var customerName = $(e.target).closest('tr').children().eq(3).text();
        var dateCOI = $(e.target).closest('tr').children().eq(6).text();
        var dateCOIConfirm = $(e.target).closest('tr').children().eq(7).text();
        if( idPress.trim() !== t("pressid") & dateCOI !== t("dateCOI") & dateCOIConfirm !== t("confirmationCOI") & idPress !== '' & active == "Active" ){
            let vaItem = dataCOI.find(va => va.idPress === idPress.trim() & va.enduserName == endUserName & va.customerName == customerName & va.active == 1);
            if ( vaItem.dateCOI == null | vaItem.dateCOIConfirm == null ){
                setEditValue(true);
                setItem(vaItem);
                setShowModal(true);
            }
        }
    };
    const reorderDataCOI = (val) => {
        switch (val){
            case '0':
                setDataCOI( dataCOIRes );
                setOptionVal("0");
                break;
            case '1':
                setDataCOI( dataCOIRes.filter((item) => item.dateCOI == null | item.dateCOIConfirm == null ) );
                setOptionVal("1");
                break;
            case '2':
                setDataCOI( dataCOIRes.filter((item) => item.alertGP != "" ) );
                setOptionVal("2");
                break;
            case '3':
                setDataCOI( dataCOIRes.filter((item) => item.alertSC != "" ) );
                setOptionVal("3");
                break;
        }
    };
    const changeActive = (bool, idCOI, idPress, data) => {
        let item = data.filter((item) => item.idPress == idPress && item.active == 1 );
        if(item.length > 0 && bool)
            setIdPressActive(true);
        else {
            setDataPressActive(bool?1:0);
            setDataPressId(idCOI);
            setActivePress(true);
        }
    };
    const sendModifiActive = () => {
        let data = new FormData();
        data.append("Action", 2);
        data.append("active", dataPressActive);
        data.append("idCOI", dataPressId);
        const handleUploadResponse = (status, response) => {
            if (response === 'allGood'){
                setOptionVal("0");
                setReloadPage(!reloadPage);
            }
        }
        connectApi.post(
            "api/Channels/uploadCOIViewAdd",
            data,
            handleUploadResponse
        ).catch((error) => {
            props.setShowModal(false);
            Swal.fire(
                "Error " + error.response?.status,
                error.response?.data, "error"
            );
        });
        setActivePress(false);
    };
    const [specialConditionDetail, setSpecialConditionDetail] = useState([]);
    const [showSCDetail, setShowSCDetail] = useState(false);
    
    const searchIdSpecialConiiton = (idSpecialCondition) => (event) => {
        event.preventDefault();
        const consolid_SC= (status, data) => {
            if (data.length>0) {
                setSpecialConditionDetail(data[0]);
                setShowSCDetail(true);
            } else {
                Swal.fire( "Error ", t("NoDatasc"), "error" );
            }
        }
        let data = new FormData();
        data.append("idSpecialCondition", idSpecialCondition);
        connectApi.post(
            'api/Channels/specialConditionbyIdSC', data, consolid_SC
        );
    }
    
    //Vistas
    const hideSCDetailsModal = () => { setShowSCDetail(false); }
    const saveSpecialCondition=() => {}
    const [orderBy, setOrderBy] = useState("enduserName");
    const [orderType, setOrderType] = useState("descending");
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 25;
    const [order, setOrder] = useState([
        'activeToogle',
        'idPressModify',
        'customerName',
        'enduserName',
        'subRegion',
        'datePrintOs',
        'dateCOI',
        'dateCOIConfirm',
        'idSpecialConditon',
        'createBy',
        'dateCreate',
        'modifyLast',
        'dateLastModify'
    ]);
    const [pressFilter, setPressFilter] = useState("");
    const [enduserNameFilter, setEnduserNameFilter] = useState("");
    const [customerNameFilter, setCustomerFilter] = useState("");
    const handlePageChange = (page) => setCurrentPage(page);
    const filteredData = filterSort(
        dataCOI, { 
            idPress: pressFilter,
            enduserName: enduserNameFilter,
            customerName: customerNameFilter,
        },
        orderBy,
        orderType
    );
    let pagedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
    );
    const handleSort = (_, { id, type }) => {
        setOrderBy(id);
        setOrderType(type);
    };
    return (
        <>
            {activePress?(
            <ConfirmationModal
                id="confirmation-modal" 
                onConfirm={() => {sendModifiActive()}}
                onClose={() => setActivePress(false)}
                show={activePress}
                title={t("requestConfirmation")}
            >
                <p>{t("requestConfirmationChangeStatusCOI")}</p>
            </ConfirmationModal>):idPressActive?(
                <AlertModal
                    id="alert-modal"
                    onClose={() => setIdPressActive(false)}
                    show={idPressActive}
                    title={t("warning")}
                >
                    <p>{t("activePressCOI")}</p>
                </AlertModal>
            ):""}
        <div>
            <Row>
                <Col 
                    style={{
                        position: "absolute",
                        marginTop: "5px",
                    }}
                >
                    {currentUser.idRole == 1?(<>
                        <div
                            style={{
                                width: '270px',
                            }}
                        >
                            <Button
                                leadingIcon={<IconPlus filled />}
                                onClick={() => setShowModal(true)}
                            >{t('addNew')}</Button>
                            
                        </div>
                        <div
                            style={{
                                marginLeft: '150px',
                                marginTop: '-38px',
                            }}
                        >
                            <RadioButtons 
                                name="radiobutton_horizontal"
                                alignment="horizontal"
                                value={optionVal}
                                onChange={(x, val) => reorderDataCOI(val)}
                                >
                                <RadioButton value="0" label={t('viewAll')} />
                                <RadioButton value="1" label={t('showNotCompleted')} />
                                <RadioButton value="2" label={t('alerShowtGP')} />
                                <RadioButton value="3" label={t('alerShowtSC')} />
                            </RadioButtons>
                        </div></>
                    ):(<></>)}
                    
                </Col>
            </Row>
            <div>
                <Table
                    onClick={currentUser.idRole == 1 ? setModalParameters : ""}
                    columns = {[
                        {
                            id: 'activeToogle',
                            label: t("Status")
                        },{
                            id: 'idPressModify',
                            label: t("pressid"),
                            filter: (
                                <Search
                                    id="press-filter"
                                    value={pressFilter}
                                    onChange={(val) => {
                                        setPressFilter(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },{
                            id: 'customerName',
                            label: t("customerName"),
                            filter: (
                                <Search
                                    id="customerName-filter"
                                    value={customerNameFilter}
                                    onChange={(val) => {
                                        setCustomerFilter(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },{
                            id: 'enduserName',
                            label: t("endUserName"),
                            filter: (
                                <Search
                                    id="enduserName-filter"
                                    value={enduserNameFilter}
                                    onChange={(val) => {
                                        setEnduserNameFilter(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },{
                            id: 'subRegion',
                            label: t("Subregion")
                        },{
                            id: 'datePrintOs',
                            label: t("datePrintOs")
                        },{
                            id: 'dateCOI',
                            label: t("dateCOI")
                        },{
                            id: 'dateCOIConfirm',
                            label: t("confirmationCOI")
                        },{
                            id: 'createBy',
                            label: t("created_by")
                        },{
                            id: 'idSpecialConditon',
                            label: t("idSpecialConditionEndDate")
                        },{
                            id: 'dateCreate',
                            label: t("dateCreate")
                        },{
                            id: 'modifyLast',
                            label: t("modify")
                        },{
                            id: 'dateLastModify',
                            label: t("modifyLastValue")
                        },
                    ]}
                    showFilters
                    columnReorder
                    data={pagedData}
                    loading={loadingData}
                    onSort={handleSort}
                    onColumnReorder={(reOrder) => setOrder(reOrder)}
                    preferences={{
                        defaultOrder: order,
                        sortBy: {
                            id: orderBy,
                            type: orderType,
                        },
                        order: order
                    }}
                    pagination={{
                        currentPage,
                        onPageChange: handlePageChange,
                        pageSize,
                        totalItems: filteredData.length,
                    }}
                />
                <div style={{ textAlign: "left" }}>
                    <Button
                        onClick={()=>{
                            setTimeout(() => {
                            const dataXlsx = filteredData.map((item) => { 
                                return {
                                    'active': item.status,
                                    'idPress': item.idPress,
                                    'alertSC': item.alertSC,
                                    'alertGP': item.alertGP,
                                    'idEndUser': item.idEndUser,
                                    'enduserName': item.enduserName,
                                    'idCustomer': item.idCustomer,
                                    'customerName': item.customerName,
                                    'subRegion': item.subRegion,
                                    'datePrintOs': item.datePrintOs,
                                    'dateCOI': item.dateCOI,
                                    'dateCOIConfirm': item.dateCOIConfirm,
                                    'idSpecialConditon': item.idSC,
                                    'EndDate': item.idSCEndDate,
                                    'createBy' : item.createBy,
                                    'dateCreate' : item.dateCreate,
                                    'modifyLast' : item.modifyLast,
                                    'dateLastModify' : item.dateLastModify,
                                };
                            });
                            const ws = XLSX.utils.json_to_sheet(dataXlsx);
                            const wb = XLSX.utils.book_new();
                            const date = moment(new Date()).format('YYYYMMDDHHmm');
                            const filename = 'COIViweData-' + date + '.xlsx';
                            const ws_name = "COIViweData";
                            XLSX.utils.book_append_sheet(wb, ws, ws_name);
                            XLSX.writeFile(wb, filename);
                            }, 750);
                        }}
                        disabled={filteredData.length === 0}
                        leadingIcon={<IconDownload />}
                        title={t('download data')}
                    >
                        {t('download')}
                    </Button>
                </div>
            </div>
            <COIViewModal
                showModal={showModal}
                setShowModal={setShowModal}
                editValue={editValue}
                setEditValue={setEditValue}
                item={item}
                setItem={setItem}
                fetchData={useEffect}
                channels={channels}
                dataCOI={dataCOI}
                reloadPage={reloadPage}
                setReloadPage={setReloadPage}
                setOptionVal={setOptionVal}
            />
            <SpecialConditionDetail 
                idSpecialCondition={null} 
                onShowModal={showSCDetail} 
                confirmationFunction={saveSpecialCondition} 
                onCloseSCDetailsModal={hideSCDetailsModal} 
                SpecialConditionDetail={specialConditionDetail} 
            />
        </div>
        </>
    );
}

export default COIView;